import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// One route only — a receipt opens in a drawer over the queue, deep-linked via
// `?receiptId=`, so there is no separate detail path.
export const rentReceiptsRoutes: RouteRecordRaw[] = [
  {
    path: routes.RENTAL_DISTRIBUTION_RECEIPTS,
    name: 'RENTAL_DISTRIBUTION_RECEIPTS',
    component: () => import('./RentReceiptsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'view_properties',
      activeMenu: 'Rental Distribution',
    },
  },
]
